const InventoryIcon = ({ fill }) => {
	return (
		<svg
			id="layer_1"
			fill="var(--icons)"
			enable-background="new 0 0 32 32"
			height="30px"
			viewBox="0 0 32 32"
			width="30px"
			xmlns="http://www.w3.org/2000/svg">
			<path d="m23 30c2.7568359 0 5-2.2431641 5-5v-18c0-2.7568359-2.2431641-5-5-5h-14c-2.7568359 0-5 2.2431641-5 5v18c0 2.7568359 2.2431641 5 5 5zm-17-23c0-1.6542969 1.3457031-3 3-3h14c1.6542969 0 3 1.3457031 3 3v18c0 1.6542969-1.3457031 3-3 3h-14c-1.6542969 0-3-1.3457031-3-3z" />
			<path d="m14 17h8c.5527344 0 1-.4477539 1-1s-.4472656-1-1-1h-8c-.5527344 0-1 .4477539-1 1s.4472656 1 1 1z" />
			<path d="m14 12h8c.5527344 0 1-.4477539 1-1s-.4472656-1-1-1h-8c-.5527344 0-1 .4477539-1 1s.4472656 1 1 1z" />
			<path d="m14 22h8c.5527344 0 1-.4477539 1-1s-.4472656-1-1-1h-8c-.5527344 0-1 .4477539-1 1s.4472656 1 1 1z" />
			<path d="m10.0195312 12c.5527344 0 1-.4477539 1-1s-.4472656-1-1-1h-.0097656c-.5517578 0-.9951172.4477539-.9951172 1s.453125 1 1.0048828 1z" />
			<path d="m10.0195312 17c.5527344 0 1-.4477539 1-1s-.4472656-1-1-1h-.0097656c-.5517578 0-.9951172.4477539-.9951172 1s.453125 1 1.0048828 1z" />
			<path d="m10.0195312 22c.5527344 0 1-.4477539 1-1s-.4472656-1-1-1h-.0097656c-.5517578 0-.9951172.4477539-.9951172 1s.453125 1 1.0048828 1z" />
		</svg>
	);
};

export default InventoryIcon;